module.exports = __webpack_public_path__ + "static/media/tgl-siyah.6cbd357a.jpg";